export const findSupplier = (list, key) => {
  for (let i = 0; i < list.length; i += 1) {
    if (list[i].key === key) {
      return list[i];
    }
  }
  return {};
};

export const parameterAffectPanelPrice = (name) => {
  const affectPanelSize = [
    'board_length',
    'board_width',
    'array_x_qty',
    'array_y_qty',
    'array_spacing_x',
    'rails_left',
    'rails_right',
    'array_spacing_y',
    'rails_top',
    'rails_bottom',
    'is_panelized',
  ];
  return affectPanelSize.indexOf(name) >= 0;
};

export const parameterForceRequote = (name) => {
  const dontForceRequote = ['part_number', 'revision', 'special_instructions', 'gerber_file_name', 'filename'];
  return dontForceRequote.indexOf(name) < 0;
};

export const calculatePanel = (source) => {
  const result = {
    array_up: null,
    array_x : null,
    array_y : null,
  };

  if (!source) {
    return result;
  }

  const data = source.toJS ? source.toJS() : source;

  const arrayXQty = parseFloat(data.array_x_qty);
  const arrayYQty = parseFloat(data.array_y_qty);
  const boardLength = parseFloat(data.board_length);
  const boardWidth = parseFloat(data.board_width);

  const okPanelLehgth = !Number.isNaN(boardLength) && !Number.isNaN(arrayXQty);
  const okPanelWidth = !Number.isNaN(boardWidth) && !Number.isNaN(arrayYQty);

  const useTabRout = data.tab_rout === '1';

  // calculate panel size in x axis
  if (okPanelLehgth) {
    result.array_x = boardLength * arrayXQty;
    const arraySpacingX = parseFloat(data.array_spacing_x) || 0.0;
    const railsLeft = parseFloat(data.rails_left) || 0.0;
    const railsRight = parseFloat(data.rails_right) || 0.0;

    result.array_x += (arrayXQty - 1) * arraySpacingX;
    result.array_x += railsLeft + (useTabRout && railsLeft > 0 ? arraySpacingX : 0.0);
    result.array_x += railsRight + (useTabRout && railsRight > 0 ? arraySpacingX : 0.0);
    result.array_x = _.round(result.array_x, 3);
  }

  // calculate panel size in y axis
  if (okPanelWidth) {
    result.array_y = boardWidth * arrayYQty;
    const arraySpacingY = parseFloat(data.array_spacing_y) || 0.0;
    const railsTop = parseFloat(data.rails_top) || 0.0;
    const railsBottom = parseFloat(data.rails_bottom) || 0.0;

    result.array_y += (arrayYQty - 1) * arraySpacingY;
    result.array_y += railsTop + (useTabRout && railsTop > 0 ? arraySpacingY : 0.0);
    result.array_y += railsBottom + (useTabRout && railsBottom > 0 ? arraySpacingY : 0.0);
    result.array_y = _.round(result.array_y, 3);
  }

  if (okPanelLehgth && okPanelWidth) {
    result.array_up = arrayXQty * arrayYQty;
  }

  return result;
};
